module.exports = __webpack_public_path__ + "static/media/bg-notfound.4be7e27f.svg";